export const API_URL = process.env.VUE_APP_API_URL;

export const API_MOTION_SEARCH = 'motion/search';
export const API_GET_CATEGORIES = 'category';

export const API_TAG_QUERY = 'tag/query/';
export const API_MOTION_QUERY = 'motion/';
export const API_TAG_QUERY_ID = 'tag/';
export const API_CATEGORY_QUERY = 'category/';
export const API_TOURNAMENT_QUERY = 'tournament/';

export const TITLE_TERMINATOR = ' - Motions Database';
